import { render, staticRenderFns } from "./saledetail.vue?vue&type=template&id=b9c55b7e&scoped=true&"
import script from "./saledetail.vue?vue&type=script&lang=js&"
export * from "./saledetail.vue?vue&type=script&lang=js&"
import style0 from "./saledetail.vue?vue&type=style&index=0&id=b9c55b7e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c55b7e",
  null
  
)

export default component.exports